import React, { createContext, useMemo, useState } from 'react';

import type { FC, ReactNode } from 'react';

export interface PostFilter {
  occupationGroupId: Array<number>;
  workplaceId: Array<number>;
  occupationId: Array<number>;
  diseaseGroupId: Array<number>;
  diseaseId: Array<number>;
  productGroupId: Array<number>;
  competitiveProductId: Array<number>;
  categoryId: Array<number>;
  activityId: Array<number>;
}

export const initialFilter = {
  occupationGroupId: [],
  workplaceId: [],
  occupationId: [],
  diseaseGroupId: [],
  diseaseId: [],
  productGroupId: [],
  competitiveProductId: [],
  categoryId: [],
  activityId: [],
} as PostFilter;

type SortOption = { id: string; label: string; shortLabel: string };

const initialKeywords = { timeline: '', posts: '', tasks: '', notifications: '' };

export const sortOptions: Array<SortOption> = [
  {
    id: 'publishedAt',
    label: '公開日の新しい順',
    shortLabel: '新着順',
  },
  {
    id: 'numberOfSameReactions',
    label: '自エリアで同じ事象有の多い順',
    shortLabel: '同じ事象順',
  },
  {
    id: 'numberOfLikeReactions',
    label: 'いいねの多い順',
    shortLabel: 'いいね順',
  },
];

export type PostFilterContextValue = {
  keyword: { timeline: string; posts: string; tasks: string; notifications: string };
  filter: PostFilter;
  sort: SortOption | undefined;
  updateKeyword: (newValye: { timeline: string; posts: string; tasks: string; notifications: string }) => void;
  updateFilter: (newValue: PostFilter) => void;
  updateSort: (newValue: SortOption | undefined) => void;
};

export const PostFilterContext = createContext<PostFilterContextValue>({
  keyword: { timeline: '', posts: '', tasks: '', notifications: '' },
  filter: initialFilter,
  sort: sortOptions[0],
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateKeyword: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateFilter: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateSort: () => {},
});

type PostFilterContextProps = {
  children: ReactNode;
};

export const PostFilterProvider: FC<PostFilterContextProps> = (props) => {
  const { children } = props;
  const [keyword, setKeyword] = useState(initialKeywords);
  const [filter, setFilter] = useState<PostFilter>(initialFilter);
  const [sort, setSort] = useState(sortOptions.find((item) => item.id === 'publishedAt'));

  const value = useMemo(
    () => ({ filter, keyword, sort, updateFilter: setFilter, updateKeyword: setKeyword, updateSort: setSort }),
    [filter, keyword, sort]
  );

  return <PostFilterContext.Provider value={value}>{children}</PostFilterContext.Provider>;
};
